import { Card, CardContent } from "../ui/card";
import { Plus } from "lucide-react";
import { CreateNavItemFormDialog } from "../layout/Sidebar/forms/CreateNavItemFormDialog";

export default function AddShortcutCard() {
  const trigger = (
    <button className="w-full h-full" data-testid="dashboard-add-shortcut">
      <div className="my-auto flex h-full flex-col justify-center gap-3 pt-4 text-center">
        <div className="mx-auto">
          <Plus size={24} className="text-neutral-500" />
        </div>
        <div className="mx-auto flex w-full gap-2 align-bottom px-2">
          <div className="mt-auto text-base font-semibold text-muted-foreground w-full">Add shortcut</div>
        </div>
      </div>
    </button>
  );

  return (
    <Card className="h-40 rounded-xl border-dashed border-border shadow-none hover:cursor-pointer hover:border-foreground/40">
      <CardContent className="h-full pt-4 p-1">
        <CreateNavItemFormDialog trigger={trigger} />
      </CardContent>
    </Card>
  );
}
